import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
// import { loadStripe } from '@stripe/stripe-js';
import Header from "../Components/Header/Header";
import { useAuthContext } from "../context/AuthContext";
import { API } from '../constant';
import { getToken } from '../helpers';
import Loading from "../Components/Hooks/Loading";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ChargesTable from './chargesTable';
import Footer from '../Components/Footer/Footer';
const SubscriptionDetails = () =>{
    const [subscription, setSubscription] = useState();
    const [subscriptionId, setSubscriptionId] = useState();
    const [loading, setLoading] = useState(true);
    const [subscriptionState, setSubscriptionState] = useState("");
    const [screenMessage, setScreenMessage] = useState("");
    const [charges, setCharges] = useState([]);
    const { user } = useAuthContext();
    const {id} = useParams();
    const hasCharges = Array.isArray(charges) && charges.length > 0;
    // const myFile ="";
   
    useEffect(() => {

        const fetchSubscription = async () => {
        try {
        const authHeaders = { Authorization: `Bearer ${getToken()}` };
        const responseData = await axios.get(`${API}/subscriptions/${id}?publicationState=preview&populate=charges`, {
            headers: authHeaders,
        });
        const subscriptionInfo = responseData.data.data.attributes;
        let planInfo = {};
        if (subscriptionInfo.stripePlanId) {
            try {
                const stripePlanId = encodeURIComponent(subscriptionInfo.stripePlanId);
                const plan = await axios.get(`${API}/plans?filters[stripePlanId][$eq]=${stripePlanId}`);
                planInfo = plan.data?.data?.[0]?.attributes || {};
            } catch (planError) {
                console.warn('Unable to fetch plan details:', planError);
            }
        }
        // console.log(subscriptionInfo);
        const dateNext = new Date(subscriptionInfo.nextPaymentDate);
        const dateStart = new Date(subscriptionInfo.startDate);
        // const dateEnd = new Date(subscriptionInfo.endDate);
        setSubscriptionState(subscriptionInfo.status);
        setCharges(subscriptionInfo.charges);
        setSubscription (
            <div className="subscription-item">
                <div className="subscription-plan-amount"><span>Amount :</span> {planInfo.amount ? `$${planInfo.amount}` : 'N/A'}</div>
                <div className="subscription-plan-Name"><span>Plan Name :</span>{planInfo.name || subscriptionInfo.stripePlanId || 'N/A'}</div>
                <div className="subscription-plan-interval"><span>Payment Interval :</span>{planInfo.interval || 'N/A'}</div>
                <div className="subscription-status"><span>Status :</span> <span id="updataStatus">{subscriptionInfo.status}</span></div>
                <div className="subscription-startdate"><span>Start Date :</span> <span>{`${dateStart.getDate()}-${dateStart.getMonth() + 1}-${dateStart.getFullYear()} ${dateStart.getHours()}:${dateStart.getMinutes()}:${dateStart.getSeconds()}`}</span></div>
                <div className="subscription-nextdate"><span>Next Payment Date:</span> <span>{`${dateNext.getDate()}-${dateNext.getMonth() + 1}-${dateNext.getFullYear()} ${dateNext.getHours()}:${dateNext.getMinutes()}:${dateNext.getSeconds()}`}</span></div>
            </div>
        );
        setSubscriptionId(subscriptionInfo.subscriptionId);
        setLoading(false);
        } catch (error) {
        setLoading(false);
        console.error(error);
        } finally{
            setLoading(false);
        }
        };
        
        fetchSubscription();
        }, [id]);

    const cancelSubscriptionHandler = async() =>{
        setLoading(true);
        try {
    //    console.log(subscriptionId);
        const response = await axios.post(`${API}/stripe/cancel-subscription`, {
            subscriptionId: subscriptionId,
        },
        {
            headers: {
            Authorization: `Bearer ${getToken()}`,
            },
        });
        const uStatus = document.getElementById("updataStatus");
        uStatus.innerHTML="Canceled";  
        
        if(response.data.subscription.status==="canceled"){
            const emailResponse = await fetch(`${API}/email/cancel-subscription`, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getToken()}`,
                },
                body: JSON.stringify({ userId:user.id }),
            });
    
            const data = await emailResponse.json();
            if(data){
                console.log("data updated successfully")
            }
            setScreenMessage(response.message);
            setSubscriptionState("");
            setLoading(false);
        }  
        // console.log(response);
        // setMessage("Subscription Cancelled successfuly");
        //window.location.replace("/");

        }
        catch (error) {
                console.log(error.message);
                setScreenMessage(error.message);
                setLoading(false);
                // setMessage(error.message);
            }
    }

    const showConfirmDialog = (e) => {
        // const paymentMethodId = e.target.getAttribute("methodid");
        confirmAlert({
          title: 'Confirm to cancel',
          message: <p>Are you sure you want to cancel this subscription?</p>,
            buttons: [
            {
            label: 'Yes',
            onClick: () => cancelSubscriptionHandler()
            },
            {
            label: 'No',
            onClick: () => {}
            }
            ]
          });
        };
    
    return(
            <div className="common-bg white-bg">
                <div className="container">
                {loading && <Loading />}

                    <Header title="My Subscription"/>
                    <div className="content-wrap">
                     <div className="my-subscriptions details">
                        <div className="items">
                        <div className="head-title">Subscription Details</div>
                        {subscription}
                        {hasCharges && <div className="head-title">Previous Charges</div>}
                        {hasCharges && <ChargesTable charges={charges}/>}
                        {screenMessage}
                        <div className="footer links">
                            <Link to="/dashboard"><button className="theme-btn">Go Back</button></Link>
                            {subscriptionState === "active" ? <button onClick={showConfirmDialog} className="theme-btn">Cancel Subscription</button> : ""}
                        </div>
                    </div>  
                    </div>
                    </div>
                    <Footer />
                </div>
            </div>
    );
}
export default SubscriptionDetails;
